// extracted by mini-css-extract-plugin
module.exports = {"rotation":"AziendaDetailTemplate_rotation__HkJbK"};